import { memo } from 'react'
import { MessagePopup } from '@renderforest/rf-components'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

interface IProps {
  isOpen: boolean
  onTryAgain: () => void
  onClose: () => void
}

const UploadFailedPopup: React.FC<IProps> = ({
  isOpen,
  onTryAgain,
  onClose
}) => (
  <MessagePopup
    isOpen={isOpen}
    type="error"
    title={translate(T.VOICE_UPLOAD_FAILED_TITLE)}
    message={translate(T.VOICE_UPLOAD_FAILED_DESCRIPTION)}
    primaryAction={{
      label: translate(T.TRY_AGAIN_LABEL),
      onClick: onTryAgain
    }}
    onClose={onClose}
  />
)

export default memo(UploadFailedPopup)
